import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import styles from './button.module.css'

const propTypes = {
    destructive: PropTypes.bool,
    icon: PropTypes.bool,
    mini: PropTypes.bool,
    noBorder: PropTypes.bool,
    primary: PropTypes.bool,
    target: PropTypes.string
}

const defaultProps = {
    target: '_blank'
}

/**
 * Render a link button component.
 *
 * <code>
 * <LinkButton href="https://www.webfleet.com/" primary> Go to: webfleet.com </LinkButton>
 * </code>
 *
 * @param {boolean} [props.destructive] - Apply destructive styles
 * @param {boolean} [props.icon] - Apply icon (only) styles
 * @param {boolean} [props.mini] - Apply mini styling for small link buttons
 * @param {boolean} [props.primary] - Apply primary styles
 * @param {string} [props.target='_blank'] - The target attribute
 * @returns {ReactElement}
 */
function LinkButton(props) {
    const { className, destructive, icon, mini, noBorder, primary, ...restProps } = props

    const linkClassName = cx(
        styles['button'],
        styles['link-button'],
        {
            [styles['primary']]: primary,
            [styles['destructive']]: destructive,
            [styles['mini']]: mini,
            [styles['icon']]: icon,
            [styles['no-border']]: noBorder
        },
        className,
        't3sel-link-button'
    )
    return <a className={linkClassName} {...restProps} />
}

LinkButton.propTypes = propTypes
LinkButton.defaultProps = defaultProps

export { LinkButton }
